/**
 @ngdoc directive
 @name showHidePassword

 @description
 displays a show/hide icon next to the target input, when clicked, modifies the target input type value.

 @usage
 <input type="password" show-hide-password>

 */

(function () {
  "use strict";
  var showHidePassword = function () {
    return {
      restrict: "A",
      controller: function ($scope, $element) {
        const showHideIconId = crypto.randomUUID()
        const showHideIconHTML = '<span id="' + showHideIconId + '" style="opacity: 0; user-select: none; transition: opacity 150ms linear; position: absolute; left: -15px;" class="google-icon">visibility_off</span>';

        $element.before(showHideIconHTML);
        const showHideIconInstance = document.getElementById(showHideIconId);

        showHideIconInstance.addEventListener("mousedown", function () {
          showHideIconInstance.innerText = "visibility";
          $element[0].type = "text";
        });

        document.addEventListener("mouseup", function () {
          showHideIconInstance.innerText = "visibility_off";
          $element[0].type = "password";
        });
        document.addEventListener("click", function ($event) {
          const inIcon = showHideIconInstance.contains($event.target);
          const inInput = $element[0].contains($event.target);
          if (!inIcon && !inInput) {
            showHideIconInstance.style.opacity = 0;
            showHideIconInstance.style.pointerEvents = "none";
          }
        });
        $element.on("focus", function () {
          showHideIconInstance.style.opacity = 1;
          showHideIconInstance.style.pointerEvents = "all";
        });
      },
    };
  };

  angular.module("app").directive("showHidePassword", showHidePassword);
})();
